import * as Period from 'constants/Period';

const CYBERSPORTDOTA2_PERIOD_MAP = {};
CYBERSPORTDOTA2_PERIOD_MAP[4200] = Period.NOT_STARTED;
CYBERSPORTDOTA2_PERIOD_MAP[4201] = Period.FIRST;
CYBERSPORTDOTA2_PERIOD_MAP[4202] = Period.SECOND;
CYBERSPORTDOTA2_PERIOD_MAP[4203] = Period.THIRD;
CYBERSPORTDOTA2_PERIOD_MAP[4204] = Period.FOURTH;
CYBERSPORTDOTA2_PERIOD_MAP[4205] = Period.FIFTH;
CYBERSPORTDOTA2_PERIOD_MAP[4206] = Period.FINISHED;

export default CYBERSPORTDOTA2_PERIOD_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/CyberSportDota2/PeriodMap.js